import {
  IFinanceApprovalLotItem,
  purchaseLotStatus
} from "@shared/lib/types/finance";

export const generateTableData = (
  influencer: IFinanceApprovalLotItem,
  lotServiceChargeRate: number
) => {
  const influencerCost = influencer.influencerCost?.cost || 0;
  const brandPrice = influencer.brandCost?.cost || 0;
  const serviceCost = Math.round(
    brandPrice * (lotServiceChargeRate || 0) * 0.01
  );
  const revenue = brandPrice + serviceCost - influencerCost;
  const revenuePercentage = brandPrice > 0 ? (revenue / brandPrice) * 100 : 0;

  return {
    key: influencer._id,
    creatorName: influencer.briefInfluencer.influencerName,
    deliverables: influencer.briefInfluencer?.deliverableV2,
    influencerCost,
    serviceCost,
    brandPrice,
    revenue,
    revenuePercentage,
    type: influencer.briefInfluencer.influencer?.type || "",
    deliverableId:
      influencer.briefInfluencer?.deliverableV2?._id || "",
    isBrandDeclined: influencer.briefInfluencer.isBrandDeclined,
    isCreatorDeclined: influencer.briefInfluencer.isCreatorDeclined,
    brandDeclinedReason: influencer.briefInfluencer.brandDeclinedReason || "",
    creatorDeclinedReason:
      influencer.briefInfluencer.creatorDeclinedReason || "",
    isCreatorRejected: influencer.status === purchaseLotStatus.Rejected,
    rejectReason: influencer.rejectReason || "",
    isApproved: influencer.status === purchaseLotStatus.Approved,
  };
};
